/* unplugin-vue-components disabled */import { render } from "./IceCubeItem.vue?vue&type=template&id=d9df5352&scoped=true"
import script from "./IceCubeItem.vue?vue&type=script&lang=js"
export * from "./IceCubeItem.vue?vue&type=script&lang=js"

import "./IceCubeItem.vue?vue&type=style&index=0&id=d9df5352&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9df5352"]])

export default __exports__